<template>
  <div
    v-show="show"
    class="app-loader-overlay"
  >
    <div class="app-loader-box">
      <b-spinner
        variant="light"
        style="width: 60px; height: 60px;"
      />
    </div>
  </div>
</template>

<script>
import { BSpinner } from 'bootstrap-vue'

export default {
  components: {
    BSpinner,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.app-loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.25);
}

.app-loader-box {
  background-color: rgba(50, 50, 50, 0.85);
  border-radius: 16px;
  display: flex;
  width: 165px;
  height: 165px;
  padding: 40px 30px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}
</style>
